/**
 * Why a capture produced no answer, in the words a customer would use.
 *
 * Deliberately unalarming, and deliberately not hidden. These are real
 * outcomes and dropping them would overstate what we measured — but a wall of
 * red in the first minute of a new account is its own kind of misrepresentation
 * about how the product usually behaves.
 */
const OUTCOMES: Readonly<Record<string, string>> = {
  login_required: "asked us to sign in",
  signup_required: "asked us to sign up",
  challenge: "checked we were human",
  no_answer: "no AI answer shown",
  site_error: "could not be reached",
  selector_drift: "we could not read the page",
};

export function outcomeLabel(state: string): string {
  return OUTCOMES[state] ?? state.replaceAll("_", " ");
}
